import axios, {AxiosInstance, AxiosResponse} from 'axios';
import config from '../../data/config';
import store from '../redux/store';

const apiClient: AxiosInstance = axios.create({
  baseURL: config.baseURL,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const refreshToken = async (): Promise<{
  accessToken: string;
  refreshToken: string;
} | null> => {
  try {
    console.log('REfresh token');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    console.log((store.getState() as any).user.data);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const refreshToken = (store.getState() as any).user.data.refreshToken;
    const response = await axios.get(
      `${config.baseURL}api/auth/authentification/refreshToken/${refreshToken}`,
    );

    const token = {
      accessToken: response.data.data.accessToken,
      refreshToken: response.data.data.refreshToken,
    };

    return token;
  } catch {
    return null;
  }
};

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  async error => {
    console.log('api interceptor', error);

    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const token = await refreshToken();

      if (token) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (store.getState() as any).user.data.accessToken = token.accessToken;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (store.getState() as any).user.data.refreshToken = token.refreshToken;

        originalRequest.headers[
          'Authorization'
        ] = `Bearer ${token.accessToken}`;

        return apiClient(originalRequest);
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
